(ns rothko.common)

(def merge-into
  (partial merge-with into))

(defn update-properties
  "Takes a hiccup vector as input and will either apply update-fn to the props
  if present or supply nil to the update-fn using the result to create the props
  map"
  [hiccup update-fn & args]
  (cond
    (map? (get hiccup 1)) (apply update hiccup 1 update-fn args)
    (and (vector? hiccup)
         (pos? (count hiccup))) (apply vector (first hiccup) (apply update-fn nil args) (rest hiccup))
    :else hiccup))
